import React, {useState} from 'react';
import {useMutation, useQuery} from '@apollo/client';
import moment from 'moment';
import Back from '../../components/Back';
import Query from '../../components/Query';
import Avatar from '../../components/Avatar';
import Icon from '../../components/Icon';
import CommentList from '../Comment/List';
import BlockList from '../Block/List';
import {QUERY_USER} from '../Client/graphql';
import {MUTATION_FORUM_CLOSE, QUERY_FORUM_DETAIL} from './graphql';
import {MUTATION_VIEW_SAVE, QUERY_VIEW_LIST} from '../View/graphql';
import {updateCreate} from '../../utils/mutation';

const ForumDetail = ({match}) => {
  const {user} = useQuery(QUERY_USER).data;

  const [isClosing, setClosing] = useState(false);

  const query = useQuery(QUERY_FORUM_DETAIL, {fetchPolicy: 'network-only', variables: {id: match.params.id}});
  const obj = query.data ? query.data.forumDetail : null;
  const isAuthor = obj && obj.user.id === user.id;

  const [close] = useMutation(MUTATION_FORUM_CLOSE, {
    onCompleted: data => {
      if (data.forumClose.obj) {
        setClosing(false);
      }
    },
  });

  const [view] = useMutation(MUTATION_VIEW_SAVE, {
    update: (cache, response) =>
      updateCreate(cache, response, {query: QUERY_VIEW_LIST, variables: {forumId: match.params.id}}),
  });

  useQuery(QUERY_VIEW_LIST, {
    variables: {forumId: match.params.id},
    onCompleted: data => {
      if (data.viewList && !data.viewList.find(x => x.userId === user.id)) {
        view({variables: {input: {forum: match.params.id}}});
      }
    },
  });

  return (
    <div className="ForumDetail py-4">
      <div className="mb-4">
        <Back />
      </div>
      <div className="row justify-content-center gx-lg-5">
        <div className="col-lg-6">
          {Query(query) || (
            <div className="bg-white border rounded px-3 py-4 mb-4">
              {obj.closed && (
                <div className="text-success mb-3">
                  <Icon name="check" />
                  <span className="ms-2">Форум закрыт</span>
                </div>
              )}
              <div className="font-4">{obj.name}</div>
              <div className="row align-items-center font-2 gx-1 text-secondary mt-2">
                <div className="col-auto">
                  <Icon name="eye" />
                </div>
                <div className="col-auto">{obj.viewsCount}</div>
                <div className="col-auto">Просмотров</div>
                <div className="col-auto ms-2">
                  <Icon name="comment" />
                </div>
                <div className="col-auto">{obj.commentsCount}</div>
                <div className="col-auto">Комментарии</div>
                <div className="col-auto ms-2">
                  <Icon name="thumbs-up" />
                </div>
                <div className="col-auto">{obj.likesCount}</div>
                <div className="col-auto">Лайков</div>
              </div>
              <div className="row gx-2 font-2 mt-1">
                {obj.tags.map(tag => (
                  <div key={tag.id} className="col-auto">
                    <div className="badge bg-warning">{tag.lesson.name}</div>
                  </div>
                ))}
              </div>
              <div className="row gx-2 mt-3">
                <div className="col-auto">
                  <Avatar user={obj.user} size={50} />
                </div>
                <div className="col">
                  <div className="row gx-2 mb-1 align-items-center">
                    <div className="col-auto fw-bold">{obj.user.fullname}</div>
                    <div className="col-auto text-muted font-2">{moment(obj.createdAt).format('DD MMM YYYY')}</div>
                  </div>
                  <div>{obj.content}</div>
                </div>
              </div>
            </div>
          )}
          <CommentList forumId={match.params.id} isAuthor={isAuthor} isClosed={!obj || obj.closed} />
        </div>
        {isAuthor && (
          <div className="col-lg-4">
            {isClosing ? (
              <div className="mb-4">
                {!obj.likesCount && (
                  <div className="text-danger mb-3">Вы никому не поставили лайк, продолжить закрытие?</div>
                )}
                <div className="row gx-3">
                  <div className="col-6">
                    <button onClick={() => close({variables: {input: {id: obj.id}}})} className="btn w-100 btn-primary">
                      Закрыть
                    </button>
                  </div>
                  <div className="col-6">
                    <button onClick={() => setClosing(false)} className="btn w-100 btn-secondary">
                      Отмена
                    </button>
                  </div>
                </div>
              </div>
            ) : obj.closed ? (
              <button
                onClick={() => close({variables: {input: {id: obj.id}}})}
                className="btn w-100 btn-secondary mb-4"
              >
                Открыть форум
              </button>
            ) : (
              <button onClick={() => setClosing(true)} className="btn w-100 btn-secondary mb-4">
                Закрыть форум
              </button>
            )}
            <BlockList forumId={match.params.id} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ForumDetail;
